<!-- <div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  d-flex justify-content-between p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <span class="text-white align-self-center">Forum</span>
                <select *ngIf="!forStudent" class="mx-1 align-self-center" id="" (change)="loadlist1($event)">
                    <option selected disabled>Choisir la classe</option>
                    <option *ngFor="let c of classrooms" [value]="c.classroom?.id">{{c.classroom?.name}}</option>
                </select>
            </div>
            <div class="p-1" style="height: 70vh;">
                <div class="row no-gutters" style="position: relative;">
                    <div class="col-12 col-md-3" style="height: 65vh; overflow-y: scroll; ">
                        <div class="mb-1" *ngFor="let d of fora" >
                            <app-information-item [myColor1]="'rgba(193, 79, 68, .3)'" [myColor2]="'rgba(193, 79, 68, .7)'" [title]="d.subject"  [content]="d.contexte"  [date]="d.created_at" (click)="loadText(d.id)" ></app-information-item>
                        </div>

                    </div>
                    <div class="col-12 col-md-9" style="position: relative;" >
                        <div class="" style="height: 65vh; overflow-y: scroll; ">
                            <ng-container *ngFor="let d of texts; let i=index">
                                <app-inbox-input *ngIf="d.sender_id==user.id" [text]="d.texte"></app-inbox-input>
                                <app-inbox-ouput *ngIf="d.sender_id!=user.id" [text]="d.texte"></app-inbox-ouput>
                               </ng-container>
                        </div>
                        <div style="position: absolute; bottom: 0; width: 100%;">
                            <textarea class="form-control" [(ngModel)]="text" name="text" (keyup.enter)="sendText()"></textarea>

                        </div>
                    </div>
                    <button *ngIf="!forStudent" (click)="add(addContent)" class="bg-white" style="position: absolute; bottom: 10px; left: 15vw; border-radius: 50%; height: 50px; width: 50px; border: 1px solid white;"><i class="fa fa-plus g-text-danger"></i></button>

                </div>
               
            </div>
        </div>
    </div>
</div> -->

<div>
    <ul>
      <li *ngFor="let m of messages">{{ m }}</li>
    </ul>
    <input [(ngModel)]="message" (keydown.enter)="sendMessage()" type="text">
    <button (click)="sendMessage()">Send</button>
  </div>

<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Ajouter un sujet</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Sujet <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="subject" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Contexte<span class="text-danger ml-2">(*)</span></label>
                <textarea name="contexte" class="form-control" ngModel maxLength="191"></textarea>
            </div>
            <div class="form-group col-12">
                <label for="">Choisir le public</label>
                <select class="mx-1 form-control" ngModel name="classroom_id">
                    <option selected disabled></option>
                    <option *ngFor="let c of classrooms" [value]="c.classroom?.id">{{c.classroom?.name}}</option>
                </select>
            </div>
           
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>